/** Fonte exclusiva dos gráficos. Altere somente este valor para trocar ou restaurar a fonte. */
export const CHART_FONT_FAMILY = 'Arial, sans-serif';
// export const CHART_FONT_FAMILY = 'VisbyCF, sans-serif';